/**
 * RoomEntryCards — two room-entry CTA cards on the f8 chat home.
 *
 * Both cards deep-link into the rooms composer: "Clear the air" scoped to an
 * existing contact (?compose=existing), "Break the ice" in new-person mode
 * (?compose=new; PPL-132 owns its in-flow fork). The composer is the
 * canonical intake for both intents (PPL-133) — f8 can still propose a room
 * conversationally, but that's an emergent chat behavior, not a wired CTA.
 *
 * Logged-out users go through /login with a relative ?redirect= carrying the
 * target — ProtectedRoute drops the destination entirely, so the redirect
 * param is the only way the intent survives the auth gate.
 *
 * PPL-127 / PPL-133.
 */

import { useNavigate } from 'react-router-dom';
import { Wind, Zap } from 'react-feather';
import { useAuth } from '../hooks/useAuth';
import '../styles/RoomEntryCards.css';

const CARDS = [
  { id: 'clear-the-air', label: 'Clear the air', qualifier: 'With someone you know', Icon: Wind, target: '/rooms?compose=existing' },
  { id: 'break-the-ice', label: 'Break the ice', qualifier: 'With someone new', Icon: Zap, target: '/rooms?compose=new' },
] as const;

export default function RoomEntryCards() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const open = (card: (typeof CARDS)[number]) => {
    if (user) navigate(card.target);
    else navigate(`/login?redirect=${encodeURIComponent(card.target)}`);
  };

  return (
    <div className="recards-grid">
      {CARDS.map((card) => (
        <button
          key={card.id}
          type="button"
          className="recards-card"
          onClick={() => open(card)}
        >
          <card.Icon size={22} className="recards-icon" aria-hidden="true" />
          <span className="recards-text">
            <span className="recards-label">{card.label}</span>
            <span className="recards-qualifier">{card.qualifier}</span>
          </span>
        </button>
      ))}
    </div>
  );
}
